import { useState, React, useEffect } from "react";
import { IoMdTrendingUp } from "react-icons/io";
import { IoMdTrendingDown } from "react-icons/io";
import { MdOutlineTrendingFlat } from "react-icons/md";
import DropdownFilter from "./DropdownFilter";

const CardItem = ({
  name,
  percentage,
  value,
  trend,
  bg,
  viewButton,
  data,
  subItem,
}) => {
  const [loading, setLoading] = useState(false);
  const [valueFetch, setValueFetch] = useState(0);
  const [filter, setFilter] = useState({
    name: "Overall",
    value: "overall_summary",
  });

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  useEffect(() => {
    setValueFetch(data ? data[filter.value][subItem] : 0);
  }, [data, filter]);
  return (
    <div
      className={` h-full w-[32.7%] rounded-lg p-4 flex flex-col justify-between ${
        !bg && "border border-[#e6ebed]"
      } bg-[${bg ? bg : "#ffffff"}] `}
    >
      <div className="  flex justify-between items-center">
        <p className=" text-sm text-[#848484] font-semibold">{name}</p>{" "}
        {!viewButton && (
          <p className=" text-xs font-medium text-[#848484]">In last 30 days</p>
        )}
        {viewButton && (
          <DropdownFilter filterValue={filter} setFilterValue={setFilter} />
        )}
      </div>
      <div className="  flex justify-between items-center mt-2">
        <p className=" text-2xl text-[#262626] font-semibold">
          {data
            ? formatToIndianRupees(valueFetch)
            : formatToIndianRupees(value) || 0}
        </p>{" "}
        {false ? (
          <button className="font-semibold text-sm text-[#00394d]">
            View{" "}
          </button>
        ) : !subItem ? (
          <p
            className={` text-xs font-semibold  px-3 py-[2px] rounded-[15px]  flex items-center ${
              loading === true
                ? "bg-[#dadada] text-[#848484]"
                : trend === "down"
                ? "bg-[#f8e9e8] text-[#d30d00]"
                : trend === "up"
                ? "bg-[#ddf5e6] text-[#47b971]"
                : " bg-[#dadada] text-[#848484]"
            }`}
          >
            {loading ? (
              "Loading..."
            ) : (
              <>
                <span className=" text-base mr-1">
                  {trend === "up" ? (
                    <IoMdTrendingUp />
                  ) : trend === "down" ? (
                    <IoMdTrendingDown />
                  ) : (
                    <MdOutlineTrendingFlat />
                  )}
                </span>{" "}
                {(percentage > 999 ? "999+" : percentage?.toFixed(0)) + "%"}
              </>
            )}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default CardItem;
